import { FunctionComponent } from 'react';

import BannerSection from '@/components/BannerSection';
import InfoBannerSection from '@/components/InfoBannerSection';
import OffersListSection from '@/components/offer/OffersListSection';
import Head from 'next/head';

const Offers: FunctionComponent = () => {
  return (
    <div className="w-full bg-white overflow-hidden tracking-[normal] text-left text-[1rem] text-gray-500">
      <Head>
        <title>Oferta</title>
        <meta name="description" content="Lista ofert firmy Binnar" />
      </Head>
      <BannerSection
        imageUrl="/offer/offer-hero.webp"
        title="Oferta"
        description="W naszym asortymencie znajdziesz innowacyjne bariery, systemy ochronne oraz usługi doradcze, wszystkie skrojone na miarę Twoich potrzeb."
      />
      <OffersListSection />
      <InfoBannerSection />
    </div>
  );
};

export default Offers;
